__turbopack_context__.v({
  "className": "libre_baskerville_8ef3b452-module__rsp0AW__className",
});
